
import { importSync as i, macroCondition, getGlobalConfig } from '@embroider/macros';
let w = window;
let d = w.define;


i("./-embroider-implicit-modules.js");

d("pds-witsmlstudio-store/app", function(){ return i("pds-witsmlstudio-store/app.js");});
d("pds-witsmlstudio-store/config/environment", function(){ return i("pds-witsmlstudio-store/config/environment.js");});
d("pds-witsmlstudio-store/router", function(){ return i("pds-witsmlstudio-store/router.js");});
d("pds-witsmlstudio-store/services/page-title", function(){ return i("pds-witsmlstudio-store/services/page-title.js");});
d("pds-witsmlstudio-store/services/cookies", function(){ return i("pds-witsmlstudio-store/services/cookies.js");});
d("pds-witsmlstudio-store/initializers/ember-simple-auth", function(){ return i("pds-witsmlstudio-store/initializers/ember-simple-auth.js");});
d("pds-witsmlstudio-store/authenticators/oauth2-password-grant", function(){ return i("pds-witsmlstudio-store/authenticators/oauth2-password-grant.js");});
d("pds-witsmlstudio-store/authenticators/oidc-auth-code", function(){ return i("pds-witsmlstudio-store/authenticators/oidc-auth-code.js");});
d("pds-witsmlstudio-store/services/notify", function(){ return i("pds-witsmlstudio-store/services/notify.js");});
d("pds-witsmlstudio-store/services/request-manager", function(){ return i("pds-witsmlstudio-store/services/request-manager.js");});
d("pds-witsmlstudio-store/services/session", function(){ return i("pds-witsmlstudio-store/services/session.js");});
d("pds-witsmlstudio-store/services/theme", function(){ return i("pds-witsmlstudio-store/services/theme.js");});
d("pds-witsmlstudio-store/services/time", function(){ return i("pds-witsmlstudio-store/services/time.js");});
d("pds-witsmlstudio-store/session-stores/application", function(){ return i("pds-witsmlstudio-store/session-stores/application.js");});
d("pds-witsmlstudio-store/initializers/app-version", function(){ return i("pds-witsmlstudio-store/initializers/app-version.js");});
d("pds-witsmlstudio-store/services/intl", function(){ return i("pds-witsmlstudio-store/services/intl.js");});
d("pds-witsmlstudio-store/templates/permissions", function(){ return i("pds-witsmlstudio-store/templates/permissions.js");});
d("pds-witsmlstudio-store/routes/permissions", function(){ return i("pds-witsmlstudio-store/routes/permissions.js");});
d("pds-witsmlstudio-store/templates/users", function(){ return i("pds-witsmlstudio-store/templates/users.js");});
d("pds-witsmlstudio-store/routes/users", function(){ return i("pds-witsmlstudio-store/routes/users.js");});
d("pds-witsmlstudio-store/templates/account", function(){ return i("pds-witsmlstudio-store/templates/account.js");});
d("pds-witsmlstudio-store/routes/account", function(){ return i("pds-witsmlstudio-store/routes/account.js");});
d("pds-witsmlstudio-store/templates/application", function(){ return i("pds-witsmlstudio-store/templates/application.js");});
d("pds-witsmlstudio-store/routes/application", function(){ return i("pds-witsmlstudio-store/routes/application.js");});
d("pds-witsmlstudio-store/templates/index", function(){ return i("pds-witsmlstudio-store/templates/index.js");});
d("pds-witsmlstudio-store/templates/login", function(){ return i("pds-witsmlstudio-store/templates/login.js");});
d("pds-witsmlstudio-store/routes/login", function(){ return i("pds-witsmlstudio-store/routes/login.js");});
d("pds-witsmlstudio-store/routes/authorize", function(){ return i("pds-witsmlstudio-store/routes/authorize.js");});
d("pds-witsmlstudio-store/routes/not-found", function(){ return i("pds-witsmlstudio-store/routes/not-found.js");});

  if (macroCondition(getGlobalConfig().fastboot?.isRunning)) {
d("pds-witsmlstudio-store/instance-initializers/setup-fetch", function(){ return i("pds-witsmlstudio-store/instance-initializers/setup-fetch.js");});
  }




if (!runningTests) {
  i("../app").default.create({"locale":"en-us","lightTheme":"pds-witsmlstudio-light","darkTheme":"pds-witsmlstudio-dark","name":"pds-witsmlstudio-store","version":"0.0.1+45f9ec9d"});
}

